import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { DataContext } from '../context/data';

export const Stats = () => {

    const { dataAPI, isLoaded } = useContext(DataContext);

    if (isLoaded) {

        return (
            <div className='row'>
                <div className='col l5 s12'>

                <h1>{dataAPI.name}</h1>
                <p>Level : {dataAPI.expLevel}</p>
                <p>Arene : {dataAPI.arena.name}</p>
                <p>Plus haut trophée : {dataAPI.bestTrophies}</p>
                <p>Trophée : {dataAPI.trophies}</p>
                <p>Total donations : {dataAPI.totalDonations}</p>
                <p>Total loose : {dataAPI.losses}</p>
                </div>
                <div className='col l5 s12'>

                <h1>{dataAPI.clan.name}</h1>
                <p>Tag : {dataAPI.clan.tag}</p>
                </div>
            </div>);
    } else {
        return (
            <div>
                <Navigate replace to='/' />
            </div>
        )
    }
};
